module.exports = __webpack_public_path__ + "img/blank-reservation.f060b8fd.svg";